import { Manager } from "@lib/types/Manager";
import { UseMutationProps, UseQueryProps } from "@lib/types";
import { AppTabProps } from "@lib/components/AppComponents/AppTabs";
import IntlMessages from "@lib/helpers/IntlMessages";
import { FaHistory } from "react-icons/fa";
import { HiUser } from "react-icons/hi";
import { AiFillLock } from "react-icons/ai";
import { LiaUserCogSolid } from "react-icons/lia";

import PersonalInfo from "./PersonalInfo";
import MyPasswordChange from "./MyPasswordChange";
import MySettings from "./MySettings";
import LoginHistory from "./LoginHistory";

export type MyProfileTabProps = {
  query: UseQueryProps<Manager>;
  updateQuery: UseMutationProps<Partial<Manager>>;
  loading?: boolean;
};

export const getMyProfileTabs = (): AppTabProps<MyProfileTabProps>[] => [
  {
    key: "personal-info",
    Title: <IntlMessages id="userProfile.personalInfo" />,
    Icon: <HiUser className="icon" />,
    Component: PersonalInfo,
  },
  {
    key: "change-password",
    Title: <IntlMessages id="userProfile.changePassword" />,
    Icon: <AiFillLock className="icon" />,
    Component: MyPasswordChange,
  },
  {
    key: "settings",
    Title: <IntlMessages id="userProfile.settings" />,
    Icon: <LiaUserCogSolid className="icon" />,
    Component: MySettings,
  },
  {
    key: "login-history",
    Title: <IntlMessages id="userProfile.loginHistory" />,
    Icon: <FaHistory className="icon" />,
    Component: LoginHistory,
  },
];
